import React from 'react';

import { LinkButton } from '@adsk/alloy-react-button';
import Dropdown, { Menu } from '@adsk/alloy-react-dropdown';
import { AlertWarningIcon } from '@adsk/alloy-react-icon';
import ProgressRing from '@adsk/alloy-react-progress-ring';

import { useTranslation } from '../i18n';

const StatusSelectBox = ({
  isLoading = false,
  hasLoadError = false,
  loadErrorContent,
  onRetry,
  children,
  ...rest
}) => {
  const { t } = useTranslation();

  const renderLoadingStatus = () => {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '72px',
        }}
      >
        <ProgressRing />
      </div>
    );
  };

  const renderErrorStatus = () => {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '72px',
        }}
      >
        <AlertWarningIcon />
        <div
          style={{
            margin: '0 2px 0 6px',
            fontSize: '12px',
            lineHeight: '16px',
          }}
        >
          {loadErrorContent}
        </div>
        {onRetry && (
          <LinkButton
            style={{
              fontSize: '12px',
              lineHeight: '16px',
            }}
            onClick={onRetry}
          >
            {t('TRY_AGAIN')}
          </LinkButton>
        )}
      </div>
    );
  };

  if (isLoading || hasLoadError)
    return (
      <Dropdown
        style={{ width: '100%' }}
        items={[]}
        renderMenu={(props) => (
          <Menu {...props}>
            {isLoading ? renderLoadingStatus() : renderErrorStatus()}
          </Menu>
        )}
      />
    );

  return children({ ...rest });
};

export default StatusSelectBox;
